class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    /*this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );*/
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  updateBodyClass() {
    const anyOpen = document.querySelector("details[open]");
    document.body.classList.toggle("js-drawer-open", !!anyOpen);
    document.body.classList.toggle("megamenu-is-opened", !!anyOpen);
  }

  connectedCallback() {
    const content = this.querySelector(".mega-menu__content");

    content &&
      content.addEventListener("mouseout", (event) => {
        const details = this.querySelector("details");

        if (details) {
          const summary = details.querySelector("summary");

          summary &&
            details.removeAttribute("open") &&
            summary.setAttribute("aria-expanded", false);
            this.updateBodyClass();
        }
      });

    this.addEventListener("mouseover", (event) => {
      const details = event.currentTarget.querySelector("details");

      if (details) {
        const summary = details.querySelector("summary");

        summary &&
          details.setAttribute("open", true) &&
          summary.setAttribute("aria-expanded", true);
          this.updateBodyClass();
      }
    });

    this.addEventListener("mouseenter", (event) => {
      const thisDetails = this.querySelector("details");
      const allDetails = document.querySelectorAll("details");
      const menuLinks = document.querySelectorAll("a.header__menu-item");

      allDetails.forEach((d) => {
        if (d !== thisDetails) {
          d.removeAttribute("open");
          this.updateBodyClass();
        }
      });

      menuLinks.forEach((link) => {
        link.addEventListener("mouseover", () => {
          allDetails.forEach((d) => d.removeAttribute("open"));
          this.updateBodyClass();
        });
      });
    });

    this.addEventListener("click", (event) => {
      if (event.currentTarget.querySelector("parent-link")) {
        window.location.href = "/collections/all";
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);
